import { translateFunc } from "client/utils/translateFunc";
import { CopyIcon } from "components/common/Icons/CopyIcon";
import { TickIcon } from "components/common/Icons/TickIcon";
import { ColorComponentType, ColorFormat, SelectedColor, Source, colorComponents } from "store/features/colorPicker/types";
import { ColorInput } from "./ColorInput/ColorInput";
import { useColorInfoCard } from "./useColorInfoCard";
import { Slider } from "components/common/Slider/Slider";

export interface ColorInfoCardProps {
    color: SelectedColor;
    colorFormat: ColorFormat;
    source: Source;
}

export const ColorInfoCard = ({ color, colorFormat, source }: ColorInfoCardProps) => {
    const { isCopied, onCopyClick, showInput, onTextClick, setShowInput, colorError, setColorError } = useColorInfoCard(
        {
            color,
            colorFormat,
            source,
        },
    );
    return (
        <div className="flex flex-col gap-2">
            <div className="cursor-pointer flex rounded-xl border border-irGray-200 dark:border-darkSurface-400 overflow-hidden">
                {showInput ? (
                    <ColorInput
                        color={color}
                        colorFormat={colorFormat}
                        setShowInput={setShowInput}
                        setColorError={setColorError}
                    />
                ) : (
                    <div className="px-4 w-full tracking-wider truncate flex items-center" onClick={onTextClick}>
                        {color[colorFormat]}
                    </div>
                )}
                <button
                    className={`text-white bg-irBlue-200 p-4 capitalize flex-shrink-0`}
                    onClick={onCopyClick}
                    aria-label={translateFunc("copy")}
                >
                    {isCopied ? <TickIcon width={18} height={20} /> : <CopyIcon />}
                </button>
            </div>
            {colorError && <div className="text-irRed-400 font-semibold">{colorError}</div>}
        </div>
    );
};
